import { render } from "./IconSignOut.vue?vue&type=template&id=25af9b44"
import script from "./IconSignOut.vue?vue&type=script&lang=js"
export * from "./IconSignOut.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__